import { Component, ContentType, Field } from 'contensis-core-api';
import { Entry } from 'contensis-management-api';
import { FormContentType } from '~/models/FormContentTypeManagement';
import { ContentTypeAssertions as assert } from '~/util/content-type/ContentTypeAssertions';

export class FirstPassStub {
  static contentType = <T extends ContentType | Component | FormContentType>(
    baseResource: T,
    defaultLanguage: string
  ) => {
    baseResource.fields = [
      {
        id: 'migrationIncomplete',
        dataType: 'string',
        name: { [defaultLanguage]: '__migration_incomplete__' },
        description: {},
        validations: {},
      },
    ] as Field[];
    if (assert.isContentType(baseResource)) {
      // Map ContentType-only fields
      baseResource.fields[0].groupId = 'main';
      baseResource.groups = [
        {
          id: 'main',
          name: {
            [defaultLanguage]: 'Main',
          },
        },
      ];
      baseResource.entryTitleField = 'migrationIncomplete';
      if (assert.isEntryContentType(baseResource)) {
        baseResource.entryDescriptionField = undefined;
        (baseResource as any).entryThumbnailField = undefined;
        baseResource.defaultParentNodeId = undefined;
      }
    }
    return baseResource;
  };

  static entry = (sourceEntry: Entry) => {
    const stubEntry = { sys: sourceEntry.sys } as Entry;
    // Populate the entryTitle field in the stub entry
    stubEntry.migrationIncomplete = '__migration_incomplete__';
    return stubEntry;
  };
}
